import { Link, useParams } from "react-router-dom";
import { PageLayout } from "../components/PageLayout.js";
import { AiUsageDashboard } from "../components/AiUsageDashboard.js";

export function AdminTenantAiUsagePage() {
  const { tenantId } = useParams();
  const id = tenantId ?? "";

  return (
    <PageLayout
      title="Tenant AI usage"
      actions={
        <div className="actions">
          <Link to={id ? `/admin/tenants/${id}` : "/admin/tenants"} className="btn">
            ← Tenant details
          </Link>
        </div>
      }
    >
      {id ? (
        <AiUsageDashboard
          hideIntro
          usagePath={`/api/admin/tenants/${encodeURIComponent(id)}/ai/usage`}
          logPath={`/api/admin/tenants/${encodeURIComponent(id)}/ai/usage/log`}
        />
      ) : (
        <div className="card muted">Missing tenant id.</div>
      )}
    </PageLayout>
  );
}
